enum DeviceType {
  CLOUD_SERVICES = 'cloudServices',
  NETWORK_CIRCUIT = 'networkCircuit',
  NETWORK_SWITCH = 'networkSwitch',
  IPAD = 'ipad',
  IPAD_MINI = 'ipadMini',
  RECEIPT_PRINTER = 'receiptPrinter',
  PAYMENT_TERMINAL = 'paymentTerminal',
  CASH_DRAWER = 'cashDrawer',
  BARCODE_SCANNER = 'barcodeScanner',
  REGISTER = 'register',
}

export const DeviceTypeString: Record<DeviceType, string> = {
  cloudServices: 'Cloud Services',
  networkCircuit: 'Network Circuit',
  networkSwitch: 'Network Switch',
  ipad: 'iPad Air',
  ipadMini: 'iPad Mini (CFD)',
  receiptPrinter: 'Receipt Printer',
  paymentTerminal: 'Payment Terminal',
  cashDrawer: 'Cash Drawer',
  barcodeScanner: 'Barcode Scanner',
  register: 'Register',
};

export default DeviceType;
